import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import cx from 'clsx';
import CenterImage from './CenterImage'; 
import transitions from '@material-ui/core/styles/transitions';

interface ImageButtonProps {
	btnImg: string;
	btnImgActive?: string;
	className?: string;
	style?: React.CSSProperties;
	maxWidth?: number | string;
	onClick?: () => void;
}

const useStyles = makeStyles((theme) => ({
	btnWrap: {
		position: 'relative',
		cursor: 'pointer',

		'& .img': {
			position: 'relative',
			width: '100%',
			height: '100%',
			transitions: 'opacity .1s ease'
		},

		// '& .btn-img-active': {
    	// 	opacity: 0,
		// 	position: 'absolute',
		// 	top: 0
		// },

		// '&:active': {
		// 	'& .btn-img-active': {
		// 		display: 'block',
    	// 		opacity: 1
		// 	},
		// },
	},
}));

const ImageButton: React.FC<ImageButtonProps> = ({
	btnImg,
	btnImgActive,
	className,
	style,
	maxWidth,
	onClick,
}) => {
	const classes = useStyles();
	const currentBtnImgActive = btnImgActive || btnImg; 

	return (
		<div className={cx(classes.btnWrap, className)} style={style} onClick={onClick} role='button' tabIndex={0}>
			<CenterImage
				src={btnImg}
				className="img btn-img-default"
				maxWidth={maxWidth}
			/>

			{/* <CenterImage
				src={currentBtnImgActive}
				className="img btn-img-active"
				maxWidth={maxWidth}
			/> */}
		</div>
	);
};

export default ImageButton;
